import BaseRadio, {BaseRadioProps} from 'components/Form/Base/BaseRadio';
import Field from 'components/Form/Field';
import {RequiredType} from 'components/Form/types';
import {getRegisterRules} from 'components/Form/utils';
import useFormError from 'hooks/useFormErrors';
import {FC, ReactNode} from 'react';

export type RadioProps = {
    classNameGroup?: string;
    helpText?: ReactNode;
    label?: ReactNode;
    requiredType?: RequiredType;
    scrollIntoViewOnError?: boolean;
} & BaseRadioProps;

const Radio: FC<RadioProps> = ({
    className,
    classNameGroup,
    disabled,
    helpText,
    isHorizontal,
    label,
    name,
    readOnly,
    required,
    requiredType,
    rules,
    scrollIntoViewOnError,
    ...rest
}) => {
    const registerRules = getRegisterRules({disabled, required, rules});

    const fieldError = useFormError(name);

    return (
        <Field
            className={className}
            disabled={registerRules?.disabled || readOnly}
            error={fieldError}
            helpText={helpText}
            label={label}
            required={!!registerRules?.required}
            requiredType={requiredType}
            scrollIntoViewOnError={scrollIntoViewOnError}
            type="radio"
        >
            {/* RequiredRules exception */}
            {/* @ts-expect-error TODO: fix type */}
            <BaseRadio
                className={classNameGroup}
                disabled={registerRules?.disabled}
                error={fieldError}
                isHorizontal={isHorizontal}
                name={name}
                readOnly={readOnly}
                required={!!registerRules?.required}
                rules={registerRules}
                {...rest}
            />
        </Field>
    );
};

export default Radio;
